import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIx1033UmlBetSubpageListStatus: 'idle',
    loadIx1033UmlBetSubpageListError: undefined as any,
    loadIx1033UmlBetSubpageListLastArgs: undefined as any,
    loadIx1033UmlBetSubpageStatus: 'idle',
    loadIx1033UmlBetSubpageError: undefined as any,
    saveIx1033UmlBetSubpageStatus: 'idle',
    saveIx1033UmlBetSubpageError: undefined as any,
    deleteIx1033UmlBetSubpageStatus: 'idle',
    deleteIx1033UmlBetSubpageError: undefined as any,

    xsp_umlagebeteiligungList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx1033UmlBetSubpageList = createAsyncThunk('ix1033UmlBetSubpageSlice/loadIx1033UmlBetSubpageList', async ({ parentModel, parentGridFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix1033UmlBetSubpageSlice.loadIx1033UmlBetSubpageListLastArgs
    if (_.isEqual(lastArgs, { parentModel, parentGridFilters }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/xsp_UmlageBeteiligung/?LOBJNR=${parentModel.OBJNR}&LTYP=0&LSNO=${parentModel.NO}&SDATUM=${parentGridFilters.filterValues.STICHTAG}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel, parentGridFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx1033UmlBetSubpageListStatus } = getState().ix1033UmlBetSubpageSlice
        return loadIx1033UmlBetSubpageListStatus !== 'pending'
    }
})

export const loadIx1033UmlBetSubpage = createAsyncThunk('ix1033UmlBetSubpageSlice/loadIx1033UmlBetSubpage', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flubt/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx1033UmlBetSubpageStatus } = getState().ix1033UmlBetSubpageSlice
        return loadIx1033UmlBetSubpageStatus !== 'pending'
    }
})

export const saveIx1033UmlBetSubpage = createAsyncThunk('ix1033UmlBetSubpageSlice/saveIx1033UmlBetSubpage', async ({ parentModel, xsp_umlagebeteiligung }: any, { rejectWithValue }: any) => {
    let promises = []
    if (xsp_umlagebeteiligung?.FLUBT_HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flubt/${ xsp_umlagebeteiligung?.FLUBT_HDR_ID }/`,
            prepareData({ OBJ: xsp_umlagebeteiligung.OBJNR, TYP: 0, FLNO: xsp_umlagebeteiligung.FLSTMNR, SNO: parentModel.NO.UMLNO }),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flubt/`,
            prepareData({ OBJ: xsp_umlagebeteiligung.OBJNR, TYP: 0, FLNO: xsp_umlagebeteiligung.FLSTMNR, SNO: parentModel.NO.UMLNO }),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIx1033UmlBetSubpageStatus } = getState().ix1033UmlBetSubpageSlice
        return saveIx1033UmlBetSubpageStatus !== 'pending'
    }
})

export const deleteIx1033UmlBetSubpage = createAsyncThunk('ix1033UmlBetSubpageSlice/deleteIx1033UmlBetSubpage', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flubt/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIx1033UmlBetSubpageStatus } = getState().ix1033UmlBetSubpageSlice
        return deleteIx1033UmlBetSubpageStatus !== 'pending'
    }
})

const Xsp_umlagebeteiligungSlice = createSlice({
    name: 'ix1033UmlBetSubpageSlice',
    initialState,
    reducers: {
        resetloadIx1033UmlBetSubpageListError: (state) => {
            state.loadIx1033UmlBetSubpageListError = undefined
        },
        resetloadIx1033UmlBetSubpage: (state) => {
            state.formItem = undefined
            state.loadIx1033UmlBetSubpageError = undefined
        },
        resetloadIx1033UmlBetSubpageError: (state) => {
            state.loadIx1033UmlBetSubpageError = undefined
        },
        resetsaveIx1033UmlBetSubpage: (state) => {
            state.formItem = undefined
            state.saveIx1033UmlBetSubpageError = undefined
        },
        resetsaveIx1033UmlBetSubpageError: (state) => {
            state.saveIx1033UmlBetSubpageError = undefined
        },
        resetdeleteIx1033UmlBetSubpageError: (state) => {
            state.deleteIx1033UmlBetSubpageError = undefined
        },
        removeFromXsp_umlagebeteiligungListById: (state, action) => {
            state.xsp_umlagebeteiligungList = state.xsp_umlagebeteiligungList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromXsp_umlagebeteiligungListByIds: (state, action) => {
            state.xsp_umlagebeteiligungList = state.xsp_umlagebeteiligungList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.xsp_umlagebeteiligungList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx1033UmlBetSubpageListStatus = 'preloaded'
            state.loadIx1033UmlBetSubpageListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.xsp_umlagebeteiligungList = []
            state.loadIx1033UmlBetSubpageListStatus = 'idle'
            state.loadIx1033UmlBetSubpageListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx1033UmlBetSubpageList.pending, (state) => {
            state.loadIx1033UmlBetSubpageListStatus = 'pending'
            state.loadIx1033UmlBetSubpageListError = undefined
        })
        builder.addCase(loadIx1033UmlBetSubpageList.fulfilled, (state, action) => {
            state.loadIx1033UmlBetSubpageListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx1033UmlBetSubpageListLastArgs = action.payload.args

            {
                state.xsp_umlagebeteiligungList = action.payload.data

            }
        })
        builder.addCase(loadIx1033UmlBetSubpageList.rejected, (state, action) => {
            state.loadIx1033UmlBetSubpageListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx1033UmlBetSubpageListError = action.error.message
            } else {
                state.loadIx1033UmlBetSubpageListError = action.payload
            }
        })

        builder.addCase(loadIx1033UmlBetSubpage.pending, (state) => {
            state.loadIx1033UmlBetSubpageStatus = 'pending'
            state.loadIx1033UmlBetSubpageError = undefined
        })
        builder.addCase(loadIx1033UmlBetSubpage.fulfilled, (state, action) => {
            state.loadIx1033UmlBetSubpageStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.xsp_umlagebeteiligungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.xsp_umlagebeteiligungList.push(newItem) }
                else { state.xsp_umlagebeteiligungList[i] = { ...state.xsp_umlagebeteiligungList[i], ...newItem } }
            }
        })
        builder.addCase(loadIx1033UmlBetSubpage.rejected, (state, action) => {
            state.loadIx1033UmlBetSubpageStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx1033UmlBetSubpageError = action.error.message
            } else {
                state.loadIx1033UmlBetSubpageError = action.payload
            }
        })

        builder.addCase(saveIx1033UmlBetSubpage.pending, (state) => {
            state.saveIx1033UmlBetSubpageStatus = 'pending'
            state.saveIx1033UmlBetSubpageError = undefined
        })
        builder.addCase(saveIx1033UmlBetSubpage.fulfilled, (state, action) => {
            state.saveIx1033UmlBetSubpageStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.xsp_umlagebeteiligungList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.xsp_umlagebeteiligungList.push(newItem) }
                else { state.xsp_umlagebeteiligungList[i] = { ...state.xsp_umlagebeteiligungList[i], ...newItem } }
            }
        })
        builder.addCase(saveIx1033UmlBetSubpage.rejected, (state, action) => {
            state.saveIx1033UmlBetSubpageStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIx1033UmlBetSubpageError = action.error.message
            } else {
                state.saveIx1033UmlBetSubpageError = action.payload
            }
        })

        builder.addCase(deleteIx1033UmlBetSubpage.pending, (state) => {
            state.deleteIx1033UmlBetSubpageStatus = 'pending'
            state.deleteIx1033UmlBetSubpageError = undefined
        })
        builder.addCase(deleteIx1033UmlBetSubpage.fulfilled, (state, action) => {
            state.deleteIx1033UmlBetSubpageStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.xsp_umlagebeteiligungList = state.xsp_umlagebeteiligungList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.xsp_umlagebeteiligungList = state.xsp_umlagebeteiligungList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIx1033UmlBetSubpage.rejected, (state, action) => {
            state.deleteIx1033UmlBetSubpageStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIx1033UmlBetSubpageError = action.error.message
            } else {
                state.deleteIx1033UmlBetSubpageError = action.payload
            }
        })

    }
})

export const {
    resetloadIx1033UmlBetSubpageListError,
    resetloadIx1033UmlBetSubpage,
    resetloadIx1033UmlBetSubpageError,
    resetsaveIx1033UmlBetSubpage,
    resetsaveIx1033UmlBetSubpageError,
    resetdeleteIx1033UmlBetSubpageError,
    removeFromXsp_umlagebeteiligungListById,
    removeFromXsp_umlagebeteiligungListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Xsp_umlagebeteiligungSlice.actions
export default Xsp_umlagebeteiligungSlice.reducer
